import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/line.service";
import { IGetLines, ILinePayload, IUpdateLine } from "../../models/line.model";

export const createLineThunk = createAsyncThunk(
  "line/createLine",
  async (payload: ILinePayload, { rejectWithValue }) => {
    try {
      const response = await api.createLine(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create line failed"
      );
    }
  }
);

export const getLinesThunk = createAsyncThunk(
  "line/getLines",
  async (payload: IGetLines, { rejectWithValue }) => {
    try {
      const response = await api.getLines(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get lines failed"
      );
    }
  }
);

export const updateLineThunk = createAsyncThunk(
  "line/updateLine",
  async ({ id, payload }: { id: string; payload: IUpdateLine }, { rejectWithValue }) => {
    try {
      const response = await api.updateLine({ id, payload });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Pause line failed"
      );
    }
  }
);

export const deleteLineThunk = createAsyncThunk(
  "line/deleteLine",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await api.deleteLine(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Delete line failed"
      );
    }
  }
);

export const createGoogleAuthInfoThunk = createAsyncThunk(
  "line/createGoogleAuthInfo",
  async (auth_code: string, { rejectWithValue }) => {
    try {
      const response = await api.createGoogleAuthInfo(auth_code);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create google auth info failed"
      );
    }
  }
);

export const getGoogleAuthInfoThunk = createAsyncThunk(
  "line/getGoogleAuthInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getGoogleAuthInfo();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get google auth info failed"
      );
    }
  }
);

export const assignAgentToLineThunk = createAsyncThunk(
  "line/assignAgentToLine",
  async (
    { id, agentId, inbound_type }: { id: string; agentId: string; inbound_type: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.assignAgentToLine(id, agentId, inbound_type);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Assign agent to line failed"
      );
    }
  }
);

export const assignWhatsappAgentToLineThunk = createAsyncThunk(
  "line/assignWhatsappAgentToLine",
  async ({ id, agentId }: { id: string; agentId: string }, { rejectWithValue }) => {
    try {
      const response = await api.assignWhatsappAgentToLine(id, agentId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Assign WhatsApp agent to line failed"
      );
    }
  }
);